import {APIJson} from "./APIJson";

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.defaults.transformResponse = (data) => {
    try {
        data = JSON.parse(data);

        if (data.data !== undefined) {
            let json = new APIJson(data);

            data = json.parseResponse();
        }

        return {...data};
    } catch (e) {
        return data;
    }
}

window._csrf_token = document.querySelector('meta[name="csrf-token"]').content;
window._user_token = JSON.parse(document.querySelector('meta[name="user-token"]').content);
